export enum AccountType {
  B2C,
  B2B1,
}
